import dispatchers from "./dispatchers.component";
import dispatchersUrls from "./dispatchers.urls";
import DispatchersTransforms from "./dispatchers.transforms";

const dispatchersModule = angular
  .module("app.components.dispatchers", [])
  .component("dispatchersPage", dispatchers)
  .service("DispatchersTransforms", DispatchersTransforms)
  .config(dispatchersUrls);

export default dispatchersModule;



// WEBPACK FOOTER //
// ./src/pages/dispatchers/dispatchers.module.js